import ApiService from '../services/ApiService';
import * as types from './ActionTypes';
import { getContacts } from './ChoiceActions';

const requestAllContactData = () => ({
  type: 'REQUEST_ALL_CONTACT_DATA',
});

const receiveAllContactDataSuccess = () => ({
  type: 'RECEIVE_ALL_CONTACT_DATA_SUCCESS',
});

const requestContactData = (identitiesId, hashId) => ({
  type: types.REQUEST_CONTACT_DATA,
  payload: {
    identitiesId,
    hashId,
  },
  requestedAt: Date.now(),
});

const receiveContactDataFailure = error => ({
  type: types.RECEIVE_CONTACT_DATA_FAILURE,
  error,
  receivedAt: Date.now(),
});

const getContactDataSuccess = ({ contact, step }) => ({
  type: types.GET_CONTACT_DATA_SUCCESS,
  payload: {
    contact,
    step,
  },
  receivedAt: Date.now(),
});

/**
 * Receive non obfuscated data for a contact
 * @param identitiesId
 * @param contact
 * @return {function(*): Promise<T>}
 */
export const getContactData = ({ identitiesId, contact }) => (dispatch) => {
  const { contactId } = contact;
  dispatch(requestContactData(identitiesId, contactId));
  return ApiService.getContactWayData({ identitiesId, hashId: contactId }).then(
    (res) => {
      const { data: { data, step }, status } = res;
      switch (status) {
        case 200:
          dispatch(getContactDataSuccess({ contact: data, step }));
          break;
        default:
          break;
      }
    },
    err => dispatch(receiveContactDataFailure(err.response)),
  );
};

/**
 * Sequence actions to get all contact data
 * @param identitiesId
 * @param contacts
 * @return {Function}
 */
export const getAllContactData = (identitiesId, contacts) => async (dispatch) => {
  for (const contact of contacts) {
    await dispatch(getContactData({ identitiesId, contact }));
  }
};

/**
 * Reload the contact list and remove session server
 * @return {Function}
 */
export const reloadContacts = () => async (dispatch, getState) => {
  const { identitiesId } = getState().identification;

  dispatch(requestAllContactData());
  await dispatch(getContacts(identitiesId));
  const { contacts } = getState().choice;
  await dispatch(getAllContactData(identitiesId, contacts));
  dispatch(receiveAllContactDataSuccess());
};
